<template>
  <div id="app">
    <!-- ログイン後はサイドメニュー表示 -->
    <div v-if="this.$store.getters.getStateIsLogin">
      <div class="split">
        <div v-if="this.$store.getters.getStateIsAdmin" class="split-left">
          <side-menu-admin/>
        </div>
        <div v-else class="split-left">
          <side-menu/>
        </div>
        <div v-if="pushTrainingFlg" class="split-right-pushtraining">
          <router-view/>
        </div>
        <div v-else class="split-right">
          <router-view/>
        </div>
      </div>
    </div>
    <!-- ログイン画面はサイドメニュー非表示 -->
    <div v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/SideMenu'
import SideMenuAdmin from '@/components/SideMenuAdmin'

export default {
  name: 'app',
  components: {
    SideMenu,
    SideMenuAdmin
  },
  data: function() {
    return {
      pushTrainingFlg: false,
    }
  },
  mounted() {
    var trainingList = ["/pushNotificationTraining", "/pushNotificationTrainingAdd", "/pushNotificationTrainingList", "/pushNotificationTrainingDetail"]
    if (trainingList.indexOf(this.$route.path) != -1) {
      this.pushTrainingFlg = true
    } else {
      this.pushTrainingFlg = false
    }
  },
  beforeUpdate() {
    var trainingList = ["/pushNotificationTraining", "/pushNotificationTrainingAdd", "/pushNotificationTrainingList", "/pushNotificationTrainingDetail"]
    if (trainingList.indexOf(this.$route.path) != -1) {
      this.pushTrainingFlg = true
    } else {
      this.pushTrainingFlg = false
    }
  }
}
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.split {
  width: 100%;
}
.split-left {
  float: left;
  width: 180px;
}
.split-right {
  padding: 30px;
  margin-left: 180px;
}
.split-right-pushtraining {
  padding: 30px;
  margin-left: 180px;
  background-color: rgb(255, 251, 203);
  height: 100vh;
}
.page_all {
  width: 800px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.page_all_wide {
  width: 900px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}

.page_header {
  display: flex;
  justify-content: space-between;
  height: 50px;
  align-items: flex-end;
  padding-bottom: 7px;
}
.title {
  text-align: left;
  font-size: 16px;
  padding-right: 10px;
}

.tbl_main {
  width: 800px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}
.tbl_main_wide {
  width: 900px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}

tbody {
  border: 1px #666666 solid;
}
table th {
  background-color: #F7F2E0;
  font-weight: normal;
  border-collapse: collapse;
  border: 1px #666666 solid;
  font-size: 12px;
}
table tr {
  border: 1px #666666 solid;
  border-collapse: collapse;
  font-size: 12px;
}
table td {
  border: 1px #666666 solid;
  border-collapse: collapse;
  font-size: 12px;
}

.btn_general {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
}
.btn_disable {
  color: #999999;
}

.btn_plus {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  font-size: 24px;
}
.btn_delete {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  color: #FF0000;
  font-size: 14px;
}
.return_link {
  height: 20px;
  text-align: left;
}
.return_link a {
  color: #c0c0c0;
  font-size: 0.8em;
}

/* 日付入力カレンダー */
.date_picker input {
  width: 370px;
}

/* ログイン画面 */
.page_all_login {
  width: 400px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.page_header_login {
  padding: 50px 0px 5px 0px;
}
.tbl_login {
  width: 400px;
}
.tbody_login {
  border: none;
}
.title_login {
  text-align: center;
  font-size: 30px;
}
.text_login_id, .text_password {
  width: 300px;
}
.btn_login {
  background-color: #144974;
  border: 1px #144974 solid;
  color: #ffffff;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
  width: 300px;
}
::placeholder {
  color: #808080;
}

/* Vuelidate */
.message {
  min-height: 20px;
  text-align: left;
}
.error {
  color: #FF0000;
}
.header_title {
  display: flex;
  justify-content: space-between;
}

.label_checkbox {
  margin: 0px;
}
</style>
